import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Grid, TextField } from "@mui/material";
import { alertService, GenericFileCrop, setBackdrop } from "common-frontend-components";
import { productsStore } from "../../../../stores/products/productsStore";
import { callCreateProductAsync } from "../../../../apis/products";
import { createImageProcessingAwaiter, PhotoUploader, } from "../../posts/Photos/PhotoUploader";
import { CategorySelector } from "../../categories/SelectCategory";
import { callCreateProductCategoryAssociationAsync } from "../../../../apis/productCategoryAssociations";
import { productCategoryAssociationsStore } from "../../../../stores/products/productCategoryAssociationsStore";
import { textColor } from "../../../../assets/styles/colors";
import { postCardStyle, textFieldStyle } from "../../../../assets/styles/styles";
import { CreateProductLinks } from "./CreateProductLinks";
import { OrderPhotos } from "../../posts/Photos/OrderPhotos";
import { callGetProductPhotoByKeyAsync, callUploadProductPhotoAsync } from "../../../../apis/productPhotos";
import { productPhotosStore } from "../../../../stores/products/productPhotosStore";
import { callGetProductIconByKeyAsync, callUploadProductIconAsync } from "../../../../apis/productIcons";
import { productIconsStore } from "../../../../stores/products/productIconsStore";
import { CreateProductPrice } from "./CreateProductPrice";
import { CreateProductSpecialPrice } from "./CreateProductSpecialPrice";
import { IndexInput } from "../../../custom/inputs/IndexInput";
export const handleOnDropWhenFormingNewProduct = (files) => {
    productsStore.setNewProduct({ ...productsStore.getNewProduct(), files });
};
const createProduct = async ({ title, description, links, price, sale, saleStartDate, saleStopDate, index, }) => {
    const product = await callCreateProductAsync({
        title, description,
        links, price, sale,
        saleStartDate,
        saleStopDate,
        index,
    });
    productsStore.setProducts([product, ...productsStore.getProducts()]);
    return product;
};
const createProductCategoryAssociations = async ({ categories }, productId) => {
    const productCategoryAssociations = [];
    for (const i of categories) {
        try {
            productCategoryAssociations.push(await callCreateProductCategoryAssociationAsync({ categoryId: i.id, productId }));
        }
        catch (e) {
            alertService.error(e);
        }
        finally {
            productCategoryAssociationsStore.setProductCategoryAssociations([...productCategoryAssociations, ...productCategoryAssociationsStore.getProductCategoryAssociations()]);
        }
    }
};
export const createProductImages = async (items, productId) => {
    const photos = [];
    for (const i of items) {
        console.log('starting upload', { ProductImageItem: i });
        const res = await callUploadProductPhotoAsync(i.file, {
            contentType: i.file.type,
            productId,
            index: i.index,
        });
        console.log('upload complete!', { res });
        const waiter = createImageProcessingAwaiter(() => callGetProductPhotoByKeyAsync(res.key));
        const photo = await waiter();
        if (photo !== null) {
            photos.push(photo);
        }
    }
    if (photos.length > 0) {
        const photoLists = [...productPhotosStore.getPhotos()];
        for (let i = 0; i < photoLists.length; i++) {
            for (const photo of photoLists[i]) {
                if (photo.productId === productId) {
                    photoLists[i] = [...photos, ...photoLists[i]];
                    productPhotosStore.setPhotos(photoLists);
                    return;
                }
                break; // productId is the same for each member in the list
            }
        }
        productPhotosStore.setPhotos([photos, ...photoLists]);
    }
};
export const createProductIcons = async (items, productId) => {
    const photos = [];
    for (const i of items) {
        console.log('starting upload', { ProductImageItem: i });
        const res = await callUploadProductIconAsync(i.file, {
            contentType: i.file.type,
            productId,
            index: i.index,
        });
        console.log('upload complete!', { res });
        const waiter = createImageProcessingAwaiter(() => callGetProductIconByKeyAsync(res.key));
        const photo = await waiter();
        if (photo !== null) {
            photos.push(photo);
        }
    }
    if (photos.length > 0) {
        const photoLists = [...productIconsStore.getIcons()];
        for (let i = 0; i < photoLists.length; i++) {
            for (const photo of photoLists[i]) {
                if (photo.productId === productId) {
                    photoLists[i] = [...photos, ...photoLists[i]];
                    productIconsStore.setIcons(photoLists);
                    return;
                }
                break; // productId is the same for each member in the list
            }
        }
        productIconsStore.setIcons([photos, ...photoLists]);
    }
};
export const onCreateProduct = async () => {
    const newProduct = productsStore.getNewProduct();
    if (newProduct.files.length > 0 && newProduct.preview === undefined)
        return alertService.error("please add a preview image with your files");
    if (newProduct.files.length === 0 && newProduct.preview !== undefined)
        return alertService.error("you have a preview image but no files to relate");
    setBackdrop(true);
    try {
        const product = await createProduct(newProduct);
        await createProductCategoryAssociations(newProduct, product.id);
        await createProductIcons([
            { file: new File([newProduct.preview?.file], "preview.png", { type: "image/png", lastModified: Date.now() }), index: 0 },
        ], product.id);
        await createProductImages(newProduct.files.map((file, index) => ({ file, index: index + 1 })), product.id);
        productsStore.clearNewProduct();
    }
    catch (e) {
        alertService.error(e);
    }
    finally {
        setBackdrop(false);
    }
};
const CreateLinks = () => _jsx(CreateProductLinks, { links: productsStore.useNewProductLinks(), setLinks: productsStore.setNewProductLinks }, void 0);
const CreatePrice = () => _jsx(CreateProductPrice, { price: productsStore.useNewProductPrice(), setPrice: productsStore.setNewProductPrice }, void 0);
const CreateSpecialPrice = () => _jsx(CreateProductSpecialPrice, { price: productsStore.useNewProductSale(), setPrice: productsStore.setNewProductSale, saleStartDate: productsStore.useNewProductSaleStartDate(), setSaleStartDate: productsStore.setNewProductSaleStartDate, saleStopDate: productsStore.useNewProductSaleStopDate(), setSaleStopDate: productsStore.setNewProductSaleStopDate }, void 0);
const SelectCategory = () => _jsx(CategorySelector, { value: productsStore.useNewProductCategories(), onChange: productsStore.onNewProductCategoryChange }, void 0);
export const PreviewImg = ({ preview, setPreview }) => _jsx(GenericFileCrop, { render: ({ selectFile }) => _jsx(Box, { onClick: selectFile, sx: { width: 285, height: 175 }, children: preview ? _jsx(Box, { component: 'img', sx: { width: '100%', height: '100%', cursor: 'pointer' }, src: preview?.imageSrc || preview?.url || "", alt: "click to change preview image" }, void 0) : _jsx(Button, { sx: { width: '100%', height: '100%' }, variant: 'contained', children: "click to add a preview image" }, void 0) }, void 0), aspect: 285 / 175, onImage: setPreview, width: 285, height: 175 }, void 0);
export const CreateProduct = () => {
    const title = productsStore.useNewProductTitle();
    const description = productsStore.useNewProductDescription();
    const preview = productsStore.useNewProductPreviewImg();
    const index = productsStore.useNewProductIndex();
    return (_jsx(Box, { sx: { minWidth: 275 }, children: _jsxs(Card, { variant: "outlined", elevation: 3, sx: postCardStyle, children: [_jsxs(CardContent, { children: [_jsx(Typography, { sx: { fontSize: 16, paddingBottom: 2, color: textColor }, color: "text.secondary", gutterBottom: true, children: "New Product" }, void 0), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, children: _jsx(TextField, { sx: textFieldStyle, label: "title", variant: "outlined", value: title, onChange: productsStore.handleNewProductTitleChange }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { sx: textFieldStyle, label: "description", variant: "outlined", value: description, onChange: productsStore.handleNewProductDescriptionChange, fullWidth: true, multiline: true }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(CreateLinks, {}, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(CreatePrice, {}, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(CreateSpecialPrice, {}, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(PreviewImg, { preview: preview, setPreview: productsStore.setNewProductPreviewImg }, void 0) }, void 0), _jsx(OrderPhotos, { useItems: productsStore.useNewProductFiles, setItems: productsStore.setNewProductFiles, parent: ({ children }) => _jsx(Grid, { item: true, xs: 12, children: children }, void 0) }, void 0), _jsx(Grid, { item: true, children: _jsx(PhotoUploader, { onDrop: handleOnDropWhenFormingNewProduct, usePreviewFiles: productsStore.useNewProductFiles, setPreviewFiles: productsStore.setNewProductFiles }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(SelectCategory, {}, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(IndexInput, { index: index, onIndexChange: productsStore.setNewProductIndex }, void 0) }, void 0)] }, void 0)] }, void 0), _jsx(CardActions, { children: _jsx("div", { style: { paddingLeft: 4, paddingRight: 4 }, children: _jsx(Button, { size: "small", onClick: onCreateProduct, children: "Create Product" }, void 0) }, void 0) }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=CreateProduct.js.map